import { render, staticRenderFns } from "./ActionContactRequest.vue?vue&type=template&id=51b89f02&scoped=true"
import script from "./ActionContactRequest.vue?vue&type=script&lang=js"
export * from "./ActionContactRequest.vue?vue&type=script&lang=js"
import style0 from "./ActionContactRequest.vue?vue&type=style&index=0&id=51b89f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b89f02",
  null
  
)

export default component.exports